import React from "react";
import "./DynamicButton.css";

const DynamicButton = ({ text, onClick, isActive }) => (
  <button
    className={`dynamic-button ${isActive ? "active" : ""}`}
    onClick={onClick}
  >
    {text}
  </button>
);

export default DynamicButton;
